import React, { useEffect, useState } from "react";
import "./Category_section.css";
import { Row, Col, Nav } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Common_heading_holder from "../../common-components/common_heading_holder/Common_heading_holder";
import {
  getAllCategories,
  getAllSubCategory,
} from "../../../features/master/masterSlice";
import Category_Subcategory_Card from "../../common-components/category_subcategory_card/Category_Subcategory_Card";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { getGroupByProduct } from "../../../features/products/productsSlice";

const STEP = 4;

const Category_section = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const queryParams = new URLSearchParams(location.search);
  const categoryId = queryParams.get("category_id");

  const app_setup = useSelector((state) => state.master.app_setup);
  const category = useSelector((state) => state.master.categories);

  const [selectedCategoryId, setSelectedCategoryId] = useState("");

  const VIEW_ALL_ID = 17;

  // keep existing API call if needed
  useEffect(() => {
    dispatch(getGroupByProduct({ p_category_id: categoryId }));
  }, [dispatch, categoryId]);

  return (
    <section className="Category_section">
      <div className="container-fluid">
        <Common_heading_holder
          heading_text={
            <>
              <span className="black-text">Our</span>
              <br />
              <span className="blue-text">Category</span>
            </>
          }
        />

        <div className="cat_subcat_div">
          <div className="flex-row p-0 mb-3">
            <Swiper
              className="mySwiper"
              pagination={{
                dynamicBullets: true,
                clickable: true,
              }}
              modules={[Pagination]}
              breakpoints={{
                0: { slidesPerView: 3, spaceBetween: 10 },
                350: { slidesPerView: 4, spaceBetween: 10 },
                576: { slidesPerView: 4, spaceBetween: 10 },
                768: { slidesPerView: 5, spaceBetween: 10 },
                992: { slidesPerView: 6, spaceBetween: 10 },
                1200: { slidesPerView: 8, spaceBetween: 10 },
              }}
            >
              {/* Categories */}
              {category?.map((slide, index) => (
                <SwiperSlide key={index} className="product-slide">
                  <Nav.Item>
                    <Nav.Link
                      eventKey={slide?.id}
                      onClick={() =>
                        navigate("/categories", {
                          state: { category_id: slide?.id },
                        })
                      }
                    >
                      <Category_Subcategory_Card
                        activeClassName={
                          Number(selectedCategoryId) === Number(slide?.id)
                            ? "activecategory"
                            : ""
                        }
                        className="product-image"
                        content={slide?.name}
                        image={process.env.REACT_APP_IMG_URL + slide?.image}
                        imgClassName="category-image"
                      />
                      <div className="triangle-right"></div>
                    </Nav.Link>
                  </Nav.Item>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Category_section;
